import React from 'react'

import './style.scss'

const Index = () => {
    return(
        <div className="empty-deliveries-container">
            <h1 className="empty-logo"><i className="fab fa-earlybirds"></i></h1>
            <h3 className="empty-title">Ingen filer lagt til</h3>
            <p className="empty-description">Det ser ikke ut som du har lastet opp noen filer, trykk på "Last opp" øverst til høre for å legge til en ny fil.</p>
        </div>
    )
}

export default Index